function flexible_getfontSize (px) {
    var docEl = document.documentElement
    
    // 版本3：
    const CONFIG = {
        MAX_WIDTH: 1920,     // PC端最大设计稿宽度
        MIN_WIDTH: 320,      // 移动端最小设计稿宽度
        MAX_FONT_SIZE: 100,  // PC端最大基准字体
        MIN_FONT_SIZE: 30    // 移动端最小基准字体
      }
      let clientWidth = docEl.clientWidth
      const { MAX_WIDTH, MIN_WIDTH, MAX_FONT_SIZE, MIN_FONT_SIZE } = CONFIG
    
      // 边界值处理优先判断
      if (clientWidth >= MAX_WIDTH) {
        return setFontSize(MAX_FONT_SIZE)
      }
      if (clientWidth <= MIN_WIDTH) {
        return setFontSize(MIN_FONT_SIZE)
      }
  
      // 使用线性插值公式计算字体大小，线性插值算法：使用数学公式 (x - x1)/(x2 - x1) * (y2 - y1) + y1 实现平滑过渡
      const fontSize = 
        ((clientWidth - MIN_WIDTH) * (MAX_FONT_SIZE - MIN_FONT_SIZE)) / 
        (MAX_WIDTH - MIN_WIDTH) + 
        MIN_FONT_SIZE
  return fontSize
}

export default flexible_getfontSize


// WEBPACK FOOTER //
// ./src/plugins/flexible.js